<template>
	<div class="bankall margin-left-sm">
		<el-row :gutter="15">
			<el-col :span="12" v-for="(item,index) in list" :key="index">
				<div class="item-box padding-sm margin-bottom-sm">
					<div class="flex align-center justify-between">
						<div>
							<div class="flex align-center ">
								<p class="text-df">{{item.bank}}</p>
								<p class="text-sm text-theme moren margin-left-xs" v-if="item.status != 2">默认</p>
							</div>
							<div class="text-sm text-ccc text-left margin-top-xs">储蓄卡</div>
							<div class=" text-left flex align-center margin-bottom-sm margin-top-sm">
								<span class="text-df text-666">卡号</span>
								<span class="fs22 margin-left-sm text-333">{{item.bank_number | filterbank}}</span>
							</div>
						</div>
						<div @click="edit(item)">
							<img class="edite" src="../../../assets/img/edite.png" >
						</div>
					</div>
					<div class="solid-top flex justify-between padding-top-xs align-center">
						<div class="flex align-center" @click="setmore(item)">
							<p v-if="item.status != 2"><i class="el-icon-success text-theme fs36"></i></p>
							<p v-if="item.status == 2"><img class="block-16" src="../../../assets/img/quan.png" alt=""></p>
							<p>{{item.status == 2?'设为默认':'设为默认'}}</p>
						</div>
						<div class="text-sm text-theme pointer" @click="dei(item)">删除</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				page:1,
				list:[]
			};
		},
		created() {
			this.getlist()
		},
		methods: {
			getlist(){
				this.ajax('get', '/api/pc/userBank/getBankList', {
					page:this.page,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.list = res.data.data
					}else{
						this.$message(res.msg);
					}
				})
			},
			dei(item){
				this.ajax('post', '/api/pc/userBank/delete', {
					id:item.id,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.getlist()
					}else{
						this.$message(res.msg);
					}
				})
			},
			setmore(item){
				this.ajax('post', '/api/pc/userBank/moren', {
					id:item.id,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.getlist()
					}else{
						this.$message(res.msg);
					}
				})
			},
			edit(item){
				let type = {
					type:'addbank',
					typeone:'wallet'
				}
				this.$emit('gettype',type)
				setTimeout(()=>{
					Bus.$emit('editdetail',item)
				},500)
			}
		},
		filters:{
			/**
			 * @description 卡号过滤中间用*代替
			 * @param {Number,String} val 卡号
			 */
			filterbank(val) {
			  if (!val) return '';
			  return val.substr(0, 4) + '********' + val.substr(-4);
			},
		}
	}
</script>

<style scoped lang="less">
	.bankall{
		width: 920px;
	}
	.block-16{
		width: 24px;
		height: 24px;
	}
	.fs36{
		font-style: 36px;
	}
	.item-box{
		width: 449px;
		height: 190px;
		background: #FFFFFF;
		box-shadow: 0px 2px 51px 0px rgba(34,34,34,0.08);
		border-radius: 8px;
		.fs22{
			font-size: 22px;
		}
		.moren{
			width: 46px;
			height: 22px;
			line-height: 22px;
			background: #FFFFFF;
			border: 1px solid #0B837C;
			border-radius: 6px;
		}
		.edite{
			width: 23px;
			height: 21px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/my/wallet/bank.vue